module.exports = __webpack_public_path__ + "static/media/ae.8fc34d93.svg";